function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 -1.65856e-06C4.46667 -1.65856e-06 -1.65856e-06 4.46667 -1.65856e-06 10C-1.65856e-06 15.5333 4.46667 20 10 20C15.5333 20 20 15.5333 20 10C20 4.46667 15.5333 -1.65856e-06 10 -1.65856e-06ZM10.0222 18.7778C5.17778 18.7778 1.26667 14.8667 1.24444 10.0222V10C1.24444 5.17778 5.15555 1.24444 10 1.24444C14.8444 1.24444 18.7556 5.15555 18.7778 10C18.7778 14.8444 14.8667 18.7556 10.0222 18.7778ZM15 10C15 10.3556 14.7111 10.8696 14.3778 10.8696H12.6087H10.8696V12.6087V14.3478C10.8696 14.7034 10.3333 15 10 15C9.64444 15 9.13043 14.6812 9.13043 14.3478V12.6087V10.8696H7.3913H5.62222C5.26666 10.8696 5 10.3333 5 10C5 9.66666 5.28889 9.13043 5.62222 9.13043H7.3913H9.13043V7.3913V5.62222C9.13043 5.26666 9.66666 5 10 5C10.3556 5 10.8696 5.28889 10.8696 5.62222V7.3913V9.13043H12.6087H14.3778C14.7111 9.13043 15 9.64444 15 10Z",
  fill: "#4F4F4F"
});

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d93b8551.svg";
export { ForwardRef as ReactComponent };